//note: states dont support new instances for each state load, should it? 
//note: It would need to pass class def instead of instance.  If it did would it create only once or for each instance?

export default class StateManager {
    constructor() {
        this.states = {};
        this.currentState = null;
    }
    addState(stateName, state) {
        this.states[stateName] = state;
    }
    removeState(stateName) {
        delete this.states[stateName];
    }
    getState(state){
        return this.states[state];
    }
    getCurrentState() {
        if (this.states[this.currentState] === undefined)
            return {};

        return this.states[this.currentState];
    }
    setState(newStateName) {

        if (this.states[newStateName] === undefined) {
            throw "StateChange Error: No state found with that key = " + newStateName;
        }
        

        //clean up
        if (this.states[this.currentState] !== undefined) {
            if (this.states[this.currentState].cleanUp !== undefined) {
                this.states[this.currentState].cleanUp();
            }
        }
        //change state
        this.currentState = newStateName;

        //setup state
        if (this.states[this.currentState] !== undefined) {
            if (this.states[this.currentState].setup !== undefined) {
                this.states[this.currentState].setup();
            }
        }
    }
}
